import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import ProductOffer from 'model/ProductOffer';
import * as sessionSelectors from 'store/state/session/sessionSelectors';

/**
 * Hook para determinar se o botão de composição deve ser exibido
 */
export const useCompositionButton = (product: ProductOffer) => {
  const isAuthenticated = useSelector(sessionSelectors.getAuthenticated);
  const isProducerAuthenticated = useSelector(sessionSelectors.isProducerAuthenticated);
  
  return useMemo(() => {
    if (!product.isCompositionEnabled) {
      return false;
    }
    
    if (!isAuthenticated) {
      return false;
    }
    
    if (isProducerAuthenticated) {
      return false;
    }
    
    if (product.availableStock <= 0) {
      return false;
    }
    
    const now = new Date();
    if (product.startDate && product.endDate) {
      const startDate = new Date(product.startDate);
      const endDate = new Date(product.endDate);
      
      if (now < startDate || now > endDate) {
        return false;
      }
    }
    
    return true;
  }, [product, isAuthenticated, isProducerAuthenticated]);
};
